<section class="w-full  py-14 md:py-20" [appScrollSection]="data?.anker">
  <div class="max-w-6xl mx-auto px-6">
    <!-- Headline -->
    <div class="text-center text-black font-primary mb-10">
      <p
        class="text-base md:text-lg"
        [innerHTML]="documentToHtmlString(data.teaser)"
      ></p>
    </div>

    <!-- Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <ng-container *ngFor="let tile of data?.tiles; let i = index">
        <div class="flex justify-center">
          <jnguyen-tile [data]="tile.fields"></jnguyen-tile>
        </div>
      </ng-container>
    </div>

    <!-- Footer text -->
    <div class="mt-14 md:mt-16 text-center text-black font-primary">
      <div
        class="max-w-4xl mx-auto text-sm sm:text-base md:text-lg leading-relaxed"
        [innerHTML]="documentToHtmlString(data.bottomText)"
      ></div>
    </div>
  </div>
</section>
